import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import swal from "sweetalert";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Head from "next/head";
import axios from "axios";

function TileReplacementModal({
  isOpen,
  onClose,
  onReplace,
  setImgUrl,
  setTileReplacement,
  tilesUsed,
  setTilesUsed,
  newImg,
  setNewImg,
}) {
  const limit = 200;

  // Initialize keywordSuggestions as an empty array
  const [keywordSuggestions, setkeywordSuggestions] = useState([]);
  const [searchText, setSearchText] = useState("");

  const getfeeds = async (e) => {
    setSearchText(e.target.value);
    try {
      const resp = await axios.get(
        `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/autosuggest?q=${e.target.value}&topQueries.count=0&popularProducts.count=${limit}&inFields.count=3&popularProducts.fields=price%2CproductUrl%2CimageUrl%2Ctitle%2CtileSize&promotedSuggestion.count=0&asd=asd`
      );
      if (resp.status === 200) {
        // Ensure the response products are an array
        setkeywordSuggestions(resp.data.response.products || []);
        console.log(resp.data.response.products);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  return (
    <Modal className="carpetlook-product-popup" show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Search Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="text"
          className="search-input"
          aria-label="Search Box"
          value={searchText}
          placeholder="Search Products"
          onChange={getfeeds}
        />
        {keywordSuggestions.length > 0 && (
          <div className="page-wrapper">
            <div
              className="obl-experience-section auto-search-bar"
              onClick={() => setkeywordSuggestions([])}
            >
              <div className="container">
                <div className="auto-search-row">
                  <div className="search-col-right">
                    <div className="aa-dataset-products">
                      {keywordSuggestions.filter((item) => item.title)
                        .length === 0 ? (
                        <div>No products found.</div>
                      ) : (
                        keywordSuggestions
                          .filter((item) => item.title)
                          .map((obj, index) => (
                            <div
                              className="search-products-col"
                              key={index}
                              onClick={() => {
                                // Use the first image from the imageUrl array for replacement
                                const selectedImage = obj.imageUrl[0];
                                setImgUrl([selectedImage]);
                                setNewImg([selectedImage]);
                                setTileReplacement(false);
                                setkeywordSuggestions([]);
                                setSearchText("");
                                onReplace(obj);
                                setTilesUsed(obj);
                              }}
                            >
                              <a>
                                <div className="thumb">
                                  <img
                                    src={
                                      obj?.imageUrl?.length
                                        ? obj.imageUrl[0]
                                        : ""
                                    }
                                    alt={obj.title}
                                  />
                                </div>
                                <div className="info">
                                  <p>{obj.title}</p>
                                </div>
                              </a>
                            </div>
                          ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

function Carpetlook() {
  const [groutApplied, setGroutApplied] = useState(true);
  const [rows, setRows] = useState(6);
  const [cols, setCols] = useState(6);
  const [rowsInGrid, setRowsInGrid] = useState(6);
  const [colsInGrid, setColsInGrid] = useState(6);
  const [rotations, setRotations] = useState([]);
  const [tileReplacement, setTileReplacement] = useState(false);
  const [totalTiles, setTolalTiles] = useState(0);
  const [rowvalErr, setRowValErr] = useState("");
  const [colvalErr, setColValErr] = useState("");
  const [selectedTilesForReplacement, setSelectedTilesForReplacement] =
    useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [tilesUsed, setTilesUsed] = useState([]);
  const [replacedTiles, setReplacedTiles] = useState({});
  const router = useRouter();
  const [pdtImg, setPdtImg] = useState(router.query.img);
  const [pdtSku, setPdtSku] = useState("");

  const [printPreviewOpen, setPrintPreviewOpen] = useState(false);
  const printContentRef = useRef(null);
  const [newImg, setNewImg] = useState([]);

  useEffect(() => {
    let totalTilesInGrid = rowsInGrid * colsInGrid;
    setTolalTiles(totalTilesInGrid);
  }, [rowsInGrid, colsInGrid]);

  useEffect(() => {
    const imgParam = router.query.img;
    setPdtImg(imgParam);
    console.log("Current path:", router.asPath);
  }, [router.query.img]);

  const rotateImage = (index) => {
    setRotations((prevRotations) => {
      const newRotations = [...prevRotations];
      newRotations[index] = (newRotations[index] || 0) + 90;
      return newRotations;
    });
  };

  const handleTileReplacement = (index) => {
    setSelectedTilesForReplacement((prevSelectedTiles) => {
      if (prevSelectedTiles.includes(index)) {
        const updatedReplacedTiles = { ...replacedTiles };
        updatedReplacedTiles[index] = newImg[newImg.length - 1];
        setReplacedTiles(updatedReplacedTiles);
        return prevSelectedTiles.filter(
          (selectedTile) => selectedTile !== index
        );
      } else {
        return [...prevSelectedTiles, index];
      }
    });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onPreviewClose = () => {
    setPreviewModalOpen(false);
  };

  const closePrintPreview = () => {
    setPrintPreviewOpen(false);
  };

  const replaceTile = () => {
    // Replace logic can be expanded if needed
    selectedTilesForReplacement.forEach((tile) => {
      // Here you can add logic for each selected tile if needed
    });
  };

  const handleReplaceButtonClick = async () => {
    if (selectedTilesForReplacement.length === 0) {
      swal("Please select at least one tile image to swap");
    } else {
      openModal();
    }
  };

  function download(dataUrl, filename) {
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // Function to download the grid as an image
  const handleDownload = async () => {
    setPreviewModalOpen(true);

    setTimeout(() => {
      const modalNode = document.getElementById("preview-modal");
      html2canvas(modalNode).then((canvas) => {
        const dataUrl = canvas.toDataURL("image/png");
        download(dataUrl, "grid_preview.png");
        setPreviewModalOpen(false);
      });
    }, 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rows > 6) {
      setRowValErr("Rows cannot be more than 6");
      setTimeout(() => setRowValErr(""), 4000);
    }
    if (rows < 1) {
      setRowValErr("At least one row is needed");
      setTimeout(() => setRowValErr(""), 4000);
    }

    if (cols > 6) {
      setColValErr("Columns cannot be more than 6");
      setTimeout(() => setColValErr(""), 4000);
    }
    if (cols < 1) {
      setColValErr("At least one column is needed");
      setTimeout(() => setColValErr(""), 4000);
    }
    if (!rowvalErr && !colvalErr) {
      setRowsInGrid(rows);
      setColsInGrid(cols);
      setRotations([]);
    }
  };

  const renderTileGrid = () => {
    return Array.from({ length: rowsInGrid }, (_, rowIndex) => (
      <div className="row" key={rowIndex}>
        {Array.from({ length: colsInGrid }, (_, colIndex) => {
          const tileIndex = rowIndex * colsInGrid + colIndex;
          const isSelectedForReplacement =
            selectedTilesForReplacement.includes(tileIndex);

          return (
            <div className="col" key={colIndex}>
              <div className={`${rowIndex}${colIndex}`}>
                <img
                  src={
                    router.asPath === "/carpetlook"
                      ? "carpet-look-default.avif"
                      : isSelectedForReplacement && newImg.length > 0
                      ? newImg[newImg.length - 1]
                      : replacedTiles[tileIndex] || pdtImg
                  }
                  alt="New tile image"
                  className={groutApplied ? "withGroutBorder" : ""}
                  style={{
                    transform: `rotate(${rotations[tileIndex] || 0}deg)`,
                  }}
                  onClick={() => rotateImage(tileIndex)}
                />
                {tileReplacement && (
                  <input
                    type="checkbox"
                    onChange={() => handleTileReplacement(tileIndex)}
                    checked={isSelectedForReplacement}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    ));
  };

  const handlePrintButtonClick = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.title = "Print Message";
    const templateContent = document.createElement("div");
    templateContent.innerHTML =
      document.getElementsByClassName("img-section")[0].innerHTML;
    printWindow.document.body.appendChild(templateContent);
    printWindow.print();
    printWindow.close();
  };

  const printModalContent = () => {
    const content = document.getElementById("preview-modal");

    if (content) {
      const pdf = new jsPDF();
      pdf.html(content, {
        callback: () => {
          pdf.save("carpetlook.pdf");
          setPreviewModalOpen(false);
        },
      });
    }
  };

  return (
    <>
      <Head>
        <title>Try Different Laying patterns | Orientbell</title>
        <meta
          name="title"
          content="Try Different Laying patterns | Orientbell"
        />
        <meta
          name="description"
          content="Orientbell Carpet look helps visualize the tiles in different laying patterns and combinations."
        />
      </Head>
      <div className="container">
        <div className="carpet_looks">
          <div className="carpet-left-sec">
            <h1>Trying different laying patterns</h1>
            <span>
              Carpet look helps visualize the tiles in different laying patterns
              and combinations.
            </span>

            <div className="tile-used-section">
              {tilesUsed.length > 0 && <h5>Tiles Used</h5>}
              {tilesUsed.length > 0 &&
                tilesUsed.map((item, index) => (
                  <ul className="tiles_added" key={index}>
                    <li>{item}</li>
                  </ul>
                ))}
            </div>
          </div>
          <div className="dynamic-section">
            <div className="carpet-logo">
              <img src="CarpetlookLogo.jpg" alt="Carpet Look Logo" />
            </div>
            <form
              className="tilecalculation"
              id="tilecalculation"
              onSubmit={handleSubmit}
            >
              <div className="grout">
                <input
                  type="checkbox"
                  checked={!groutApplied}
                  onChange={() => setGroutApplied(!groutApplied)}
                />
                <label>Select to remove the grout between the tiles</label>
              </div>

              <div className="img-section">
                {rowsInGrid > 0 &&
                  rowsInGrid < 7 &&
                  colsInGrid > 0 &&
                  colsInGrid < 7 &&
                  renderTileGrid()}
              </div>

              <div className="replace-tile">
                <input
                  type="checkbox"
                  checked={tileReplacement}
                  onChange={() => setTileReplacement(!tileReplacement)}
                />
                <label>Select the tile to be replaced with another tile</label>
                {tileReplacement && (
                  <Button onClick={handleReplaceButtonClick}>
                    Click to Replace Tile
                  </Button>
                )}
                <TileReplacementModal
                  isOpen={isModalOpen}
                  onClose={closeModal}
                  onReplace={replaceTile}
                  setImgUrl={setImgUrl}
                  setTileReplacement={setTileReplacement}
                  tilesUsed={tilesUsed}
                  setTilesUsed={setTilesUsed}
                  newImg={newImg}
                  setNewImg={setNewImg}
                />
              </div>

              <div className="measurement">
                <div>
                  <label>Number of rows*</label>
                  <input
                    type="number"
                    name="rows"
                    value={rows}
                    onChange={(e) => setRows(e.target.value)}
                    required
                  />
                  {rowvalErr && (
                    <p className="error text-danger">{rowvalErr}</p>
                  )}
                </div>
                <div>
                  <label>Number of columns*</label>
                  <input
                    type="number"
                    name="cols"
                    value={cols}
                    onChange={(e) => setCols(e.target.value)}
                    required
                  />
                  {colvalErr && (
                    <p className="error text-danger">{colvalErr}</p>
                  )}
                </div>
              </div>
              <div className="measurement-button">
                <button type="submit" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </form>

            <div className="note">
              <h6>
                Note: Use of Spacer is strongly recommended for laying tiles
              </h6>
            </div>
          </div>
          <div className="carpet-sec-right">
            <div className="carpet-sec-button-bx">
              <ul>
                <li>
                  <div onClick={() => setPreviewModalOpen(true)}>Preview</div>
                </li>
                <li>
                  <a href="https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/">
                    <div>
                      <img src="whatsapp.svg" alt="Icon" />
                    </div>
                  </a>
                </li>
                <li>
                  <div onClick={handleDownload}>Download</div>
                </li>
              </ul>
            </div>
          </div>
          <Modal
            className="carpetlook-product-popup"
            id="preview-modal"
            show={previewModalOpen}
            onHide={onPreviewClose}
          >
            <Modal.Header closeButton />
            <Modal.Body>{renderTileGrid()}</Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default Carpetlook;
